import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { GoogleCalendarAuthService } from '../Provider/google-calendar-auth.service';
import { isExpiredCalendarConnectionError } from '../utils/google-calendar-consent.utils';

/** Global HTTP error passthrough. Auth 401 handling is done in `authRefreshInterceptor`. */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const googleCalendarAuth = inject(GoogleCalendarAuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (isExpiredCalendarConnectionError(error)) {
        googleCalendarAuth.markConnectionExpired();
      }
      return throwError(() => error);
    })
  );
};
